import React, { useCallback } from 'react';
import {
  Icon,
  Button,
  Tooltip,
  MediaObject,
} from '@salesforce/design-system-react';
import VidyardEmbed from '@vidyard/embed-code';

const articles = [
  {
    title: 'Questionnaire',
    content: 'Use the Hero6 Questionnaire to prepare for your workshop.',
    link: 'https://salesforce.quip.com/nLb2AnTpluED',
    stage: '',
    image: (
      <Icon
        assistiveText={{ label: 'Questionnaire' }}
        category="doctype"
        name="quip_doc"
        size="small"
      />
    ),
  },
  {
    title: 'Trailhead Module',
    content: 'Learn more about the Hero6 storytelling process on Trailhead.',
    link:
      'https://org62.my.trailhead.com/en/content/employee/modules/hero-storytelling-solutions',
    stage: '',
    image: (
      <span className="slds-icon_container" title="Hero6 Trailhead">
        <img
          src="/logos/hero6_badge.png"
          className="slds-icon slds-icon_large"
          alt="Hero6 Trailhead"
          style={{ height: '2rem', width: '2rem'}}
        />
      </span>
    ),
  },
  {
    title: 'Navigating the Pre-work',
    content:
      'Follow along as we learn how to complete and use the Hero6 Questionnaire to set our Hero6 app experience up for success.',
    link: 'https://salesforce.vidyard.com/watch/AFXk14994tNGrZXtcgg4Zp',
    embedLink: 'https://play.vidyard.com/AFXk14994tNGrZXtcgg4Zp.jpg',
    Id: 'AFXk14994tNGrZXtcgg4Zp',
    stage: '',
    image: (
      <Icon
        assistiveText={{ label: 'Video' }}
        category="doctype"
        name="video"
        size="small"
      />
    ),
  },
  {
    title: 'Determining the Business Challenge',
    content:
      'Let’s tackle the first stage of the Hero framework - determining our business challenge. Here we identify the backbone of our story.',
    link: 'https://salesforce.vidyard.com/watch/41HWTM6UFXii9wLmR1CBry',
    embedLink: 'https://play.vidyard.com/41HWTM6UFXii9wLmR1CBry.jpg',
    Id: '41HWTM6UFXii9wLmR1CBry',
    stage: 'Business Challenge',
    image: (
      <Icon
        assistiveText={{ label: 'Video' }}
        category="doctype"
        name="video"
        size="small"
      />
    ),
  },
  {
    title: 'Identifying your Personas',
    content:
      'This stage of the Hero helps you understand your personas’ experiences and envision how our solutions solve their key business challenges.',
    link: 'https://salesforce.vidyard.com/watch/N5UTFtcrSauG3DA6i1iJDX',
    embedLink: 'https://play.vidyard.com/N5UTFtcrSauG3DA6i1iJDX.jpg',
    Id: 'N5UTFtcrSauG3DA6i1iJDX',
    stage: 'Personas',
    image: (
      <Icon
        assistiveText={{ label: 'Video' }}
        category="doctype"
        name="video"
        size="small"
      />
    ),
  },
  {
    title: 'Defining your Milestones',
    content:
      'Let’s start building our story! The 3rd and 4th stage is combined in this walkthrough of how we use key moments to structure our vision.',
    link: 'https://salesforce.vidyard.com/watch/2uzqBNLgAWGJ6LL66aGGAU',
    embedLink: 'https://play.vidyard.com/2uzqBNLgAWGJ6LL66aGGAU.jpg',
    Id: '2uzqBNLgAWGJ6LL66aGGAU',
    stage: 'Milestones',
    image: (
      <Icon
        assistiveText={{ label: 'Video' }}
        category="doctype"
        name="video"
        size="small"
      />
    ),
  },
  {
    title: 'Connecting your Milestones',
    content:
      'Now that we have the key milestones of our vision, we can connect each milestone with all the additional touch-points on our Hero’s journey.',
    link: 'https://salesforce.vidyard.com/watch/qvzqKGVjgZ3F3jq5naHVok',
    embedLink: 'https://play.vidyard.com/qvzqKGVjgZ3F3jq5naHVok.jpg',
    Id: 'qvzqKGVjgZ3F3jq5naHVok',
    stage: 'Milestone Connectors',
    image: (
      <Icon
        assistiveText={{ label: 'Video' }}
        category="doctype"
        name="video"
        size="small"
      />
    ),
  },
  {
    title: 'Product Overlay and Deliverables',
    content:
      'We wrapped up our story and now we get to associate Salesforce products and solutions to each of element and bring the vision to life with templates.',
    link: 'https://salesforce.vidyard.com/watch/d5H55PSrDiVm7DbZckKKnp',
    embedLink: 'https://play.vidyard.com/d5H55PSrDiVm7DbZckKKnp.jpg',
    Id: 'd5H55PSrDiVm7DbZckKKnp',
    stage: 'Product Overlays',
    image: (
      <Icon
        assistiveText={{ label: 'Video' }}
        category="doctype"
        name="video"
        size="small"
      />
    ),
  },
];

const EnablementCards = (props) => {
  const handleClick = useCallback((article) => {
    if (!article.Id) {
      window.open(article.link, '_blank');
    } else {
      var players = VidyardEmbed.api.getPlayersByUUID(article.Id);
      var player = players[0];
      player.showLightbox();
    }
  });

  return (
    <div>
      {articles.map((article) => {
        if (props.stage === article.stage) {
          return (
            <div 
              style={{ fontSize: '.8rem'}}>
                Watch the <span style={{ color: '#1B96FF', fontWeight: '600', cursor: 'pointer'}} onClick={() => handleClick(article)}>Education Demo</span>
              <div style={{ display: 'none' }}>
                <img
                  alt="vidyard video"
                  style={{ maxWidth: '100%', width: 60 }}
                  className="vidyard-player-embed"
                  src={article.embedLink}
                  data-uuid={article.Id}
                  data-v="4"
                  data-type="lightbox"
                />
              </div>
            </div>
          )
        } else if (props.stage === 'Entry') {
          return (
            <li
              className="slds-item"
              key={article.link}
              onClick={() => handleClick(article)}
              style={{ cursor: 'pointer', listStyleType: 'none', color: 'white' }}
              className="slds-p-horizontal_small slds-p-vertical_x-small"
            >
              <MediaObject
                body={
                  <div>
                    <div className="slds-grid slds-grid_vertical-align-center">
                      <div className="slds-size_11-of-12">
                        <h1 style={{ fontSize: '.75rem'}}>
                          {article.title}
                        </h1>
                      </div>
                      <div className="slds-size_1-of-12 slds-align_absolute-center">
                        <Tooltip
                          id="base"
                          align="right"
                          content={article.content}
                          dialogClassName="dialog-classname"
                        />
                      </div>
                    </div>
                    <div style={{ display: 'none' }}>
                      <img
                        alt="vidyard video"
                        style={{ maxWidth: '100%', width: 60 }}
                        className="vidyard-player-embed"
                        src={article.embedLink}
                        data-uuid={article.Id}
                        data-v="4"
                        data-type="lightbox"
                      />
                    </div>
                  </div>
                }
                figure={article.image}
                verticalCenter
              />
            </li>
          );
        }
      })}
    </div>
  );
};

export default EnablementCards;
